const truncateAddress = (address: string, length: number = 4): string =>
  `${address.slice(0, 2 + length)} . . . ${address.slice(-length)}`;

const capitalizeFirstLetter = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export { truncateAddress, capitalizeFirstLetter };
